import React, { useEffect, useRef, useState } from "react";
import { useHistory } from 'react-router-dom';
import { Alert, Box, Button, ComboBox, Form, Input, Row } from "@intech/web-ui";
import { RelacionamentoService, FuncionarioService } from "@services";
import { RelacionamentoEntidade, WebAssuntoEntidade } from "@entidades";
import { LoadingComponent, MasterPage } from "@components";
import { NumFuncionalidade } from "../../helpers/BloqueioFuncionalidade";

export const Relacionamento: React.FC = (props) => {
  const history = useHistory();
  const form = useRef<Form>(null);

  const [AlertText, setAlertText] = useState<string>("");
  const [AlertType, setAlertType] = useState<"success" | "danger" | "warning" | "info">("danger");
  const [Email, setEmail] = useState<string>("");
  const [Assunto, setAssunto] = useState<string>("");
  const [ListaAssunto, setListaAssunto] = useState<Array<WebAssuntoEntidade>>(new Array<WebAssuntoEntidade>());
  const [Mensagem, setMensagem] = useState<string>("");
  const [Loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const dados = await FuncionarioService.Buscar();
        const listaAssunto = await RelacionamentoService.BuscarListaAssunto();

        setEmail(dados.DadosPessoais.EMAIL_AUX);
        setListaAssunto(listaAssunto);
        setLoading(false);
      }
      catch (err) {
        if (err.message.indexOf("401") > -1) {
          history.push("/login");
        }
        setLoading(false);
      }
    })();
  }, [history]);

  async function Validar() {
    try {
      if (Email === "") {
        setAlertText('Campo "Seu e-mail" obrigatório.');
        setAlertType("danger");
        return null;
      }

      if (Assunto === "") {
        setAlertText('Campo "Assunto" obrigatório.');
        setAlertType("danger");
        return null;
      }

      if (Mensagem === "") {
        setAlertText('Campo "Mensagem" obrigatório.');
        setAlertType("danger");
        return null;
      }
      if (form?.current?.validate()) {

        const mensagem = new RelacionamentoEntidade();
        mensagem.Email = Email;
        mensagem.Assunto = Assunto;
        mensagem.Mensagem = Mensagem;

        await RelacionamentoService.ValidarEmail(mensagem.Email);

        const res = await RelacionamentoService.Enviar(mensagem);

        setAlertText(res);
        setAlertType("info");
      }
    }
    catch (e) {
      const error = e.response ? e.response.data : e;
      setAlertText(error);
    }
  }

  if (Loading) {
    return (
      <MasterPage Funcionalidade={NumFuncionalidade.FALE_CONOSCO} {...props}>
        <LoadingComponent />
      </MasterPage>
    );
  }

  return (
    <MasterPage Funcionalidade={NumFuncionalidade.FALE_CONOSCO} {...props}>
      <Box title={"Envie-nos uma mensagem!"}>

        <Form ref={form}>

          <Input
            value={Email}
            onChange={setEmail}
            title={"Seu e-mail"}
            required
          />

          <div className="form-group">
            {ListaAssunto.length > 0 && (
              <ComboBox
                value={Assunto}
                title={"* Assunto"}
                emptyText={"Selecione um assunto"}
                memberName={"TXT_ASSUNTO"}
                memberValue={"OID_ASSUNTO"}
                data={ListaAssunto}
                onChange={setAssunto}
              />
            )}

            {ListaAssunto.length === 0 &&
              <Alert type='danger'>
                Nenhum assunto encontrato no sistema!
                </Alert>
            }
          </div>

          <Input
            title={"Mensagem"}
            value={Mensagem}
            onChange={setMensagem}
            type={"textarea"}
            max={4000}
            rows={10}
            required
          />

          <Button
            onClick={Validar}
            title={"Enviar"}
            type={"primary"}
            usesLoading
            loadingText={"Enviando..."}
          />

          <br />
          <br />
          <Alert formAlert type={AlertType} />
          {AlertText !== "" && <Alert type={AlertType}>
            {AlertText}
          </Alert>}
        </Form>
      </Box>
    </MasterPage>
  );
}
